import { Link } from "react-router-dom";
import { cn } from "~/lib/utils";

interface PlaceListItemProps {
  to: string;
  className?: string;
  children: React.ReactNode;
}

export function PlaceListItem({ to, className, children }: PlaceListItemProps) {
  return (
    <Link
      to={to}
      className={cn("block focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:outline-none", className)}
    >
      {children}
    </Link>
  );
}
